<div class="container two-column">
  <div class="locations-content">
    <div class="section-heading">
      <h2>{{'landing.locations.title'|traduccion}}</h2>
      <p>{{'landing.locations.subtitle'|traduccion}}</p>
    </div>

    <div class="location-list" [attr.aria-label]="'nav.locations'|traduccion">
      @for (location of data; track location.id) {
        <div class="location-row">
          <button
            type="button"
            class="location-select"
            [class.active]="selectedLocation?.id === location.id"
            [attr.aria-pressed]="selectedLocation?.id === location.id"
            [attr.aria-label]="'landing.locations.showOnMap'|traduccion:{location: location.name}"
            (click)="selectLocation(location)">
            <span class="location-copy">
              <span class="location-name">{{ location.name }}</span>
              <span class="location-address">{{ location.address }}</span>
            </span>
          </button>
          <a class="location-reserve" [routerLink]="[language.path('reserve'), location.code, 'locker-type']" [attr.aria-label]="'landing.locations.reserveAt'|traduccion:{location: location.name}">{{'landing.locations.reserveHere'|traduccion}}</a>
          <button type="button" class="location-map-action" [attr.aria-label]="'landing.locations.showOnMap'|traduccion:{location: location.name}" (click)="selectLocation(location)">
            <span class="chevron" aria-hidden="true">›</span>
          </button>
        </div>
      }
    </div>

    <a class="section-link" [routerLink]="language.path('locker-locations')">{{'landing.viewAllLocations'|traduccion}} <span aria-hidden="true">→</span></a>
  </div>

  <div class="map-card" [attr.aria-label]="'landing.locations.mapLabel'|traduccion">
    <div #mapContainer class="map-container"></div>
    @if (mapLoading) {
      <div class="map-loading" role="status">{{'landing.locations.loadingMap'|traduccion}}</div>
    }
    @if (selectedLocation) {
      <div class="map-location-card" aria-live="polite">
        <div>
          <strong>{{ selectedLocation.name }}</strong>
          <p>{{ selectedLocation.address }}</p>
        </div>
      </div>
    }
  </div>
</div>
